import React, { forwardRef, useCallback, useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, styled, ThemeProvider } from '@mui/material/styles';
import useCaptcha from 'use-offline-captcha';
import RefreshIcon from '@mui/icons-material/Refresh';
import LoadingButton from '@mui/lab/LoadingButton';
import SendIcon from '@mui/icons-material/Send';
import { useTranslation } from "react-i18next";
import { CardActions, CardContent, CircularProgress, colors, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Fab, FormControl, FormHelperText, FormLabel, IconButton, List, ListItem, ListItemAvatar, ListItemText, MenuItem, Paper, Radio, RadioGroup, Slide, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, ToggleButton, ToggleButtonGroup, useMediaQuery } from '@mui/material';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import DoneIcon from '@mui/icons-material/Done';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import RemoveRedEyeTwoToneIcon from '@mui/icons-material/RemoveRedEyeTwoTone';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

function Copyright(props) {
    return (
        <Typography variant='body2' color="text.secondary" align='center' {...props}>
            {'Copyright © '}
            < Link color="inherit" href="https://wbsedcl.in/" >
                WEST BENGAL STATE ELECTRICITY DISTRIBUTION COMPANY LIMITED. All Rights Reserved.
            </Link > {' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography >
    );
}

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme({
    components: {
        MuiFormLabel: {
            styleOverrides: {
                asterisk: {
                    color: "#db3131",
                    "&$error": {
                        color: "#db3131",
                    },
                },
            },
        },
    },
});

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const consumerIdPattern = /^\d{3,10}$/;
const mobileNumberPattern = /^\d{10}$/;
const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export default function GrievanceStatusForm(props) {
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery('(min-width:350px)');
    const isBiggerScreen = useMediaQuery('(min-width:769px)');

    const [typeOfQueries, setTypeOfQueries] = useState(["Consumer ID", "Application No", "Acknowledgement Number", "Docket Number"]);
    const [typeOfQuery, setTypeOfQuery] = useState("");
    const [typeOfQueryErrorMessage, setTypeOfQueryErrorMessage] = useState("");
    const [typeOfQueryValid, setTypeOfQueryValid] = useState(false);
    const [typeOfQueryError, setTypeOfQueryError] = useState(false);

    const [consumerId, setConsumerId] = useState("");
    const [consumerIdErrorMessage, setConsumerIdErrorMessage] = useState("");
    const [consumerIdDisabled, setConsumerIdDisabled] = useState(false);
    const [consumerIdValid, setConsumerIdValid] = useState(false);
    const [consumerIdError, setConsumerIdError] = useState(false);

    const [captchaText, setCaptchaText] = useState("");
    const [captchaTextErrorMessage, setCaptchaTextErrorMessage] = useState("");
    const [captchaTextValid, setCaptchaTextValid] = useState(false);
    const [captchaTextError, setCaptchaTextError] = useState(false);

    const [isMobileFetched, setIsMobileFetched] = useState(false);
    const [isMobileVerified, setIsMobileVerified] = useState(false);
    const [isOTPSent, setIsOTPSent] = useState(false);
    const [isFinalSubmitDone, setIsFinalSubmitDone] = useState(false);

    const [verifyLoading, setVerifyLoading] = useState(false);
    const [sendOtpLoading, setSendOtpLoading] = useState(false);
    const [otpVerifyLoading, setOtpVerifyLoading] = useState(false);
    const [finalSubmitLoading, setFinalSubmitLoading] = useState(false);

    const [hasMobileNumber, setHasMobileNumber] = useState(true);
    const [hideMobileEdit, setHideMobileEdit] = useState(true);

    const [consumerName, setConsumerName] = useState("");
    const [consumerNameErrorMessage, setConsumerNameErrorMessage] = useState("");
    const [consumerNameValid, setConsumerNameValid] = useState(false);
    const [consumerNameError, setConsumerNameError] = useState(false);

    const [consumerOriginalMobile, setConsumerOriginalMobile] = useState("");
    const [consumerMobile, setConsumerMobile] = useState("");
    const [consumerMobileErrorMessage, setConsumerMobileErrorMessage] = useState("");
    const [consumerMobileValid, setConsumerMobileValid] = useState(false);
    const [consumerMobileError, setConsumerMobileError] = useState(false);

    const [encryptedOtp, setEncryptedOtp] = useState("");
    const [otpGotFromApi, setOtpGotFromApi] = useState("");
    const [otp, setOtp] = useState("");//538240
    const [otpErrorMessage, setOtpErrorMessage] = useState("");
    const [otpValid, setOtpValid] = useState(false);
    const [otpError, setOtpError] = useState(false);

    const [supplyOfc, setSupplyOfc] = useState("");

    const [consumerEmail, setConsumerEmail] = useState("");
    const [consumerEmailErrorMessage, setConsumerEmailErrorMessage] = useState("");
    const [consumerEmailValid, setConsumerEmailValid] = useState(true);
    const [consumerEmailError, setConsumerEmailError] = useState(false);

    const [addressLine1, setAddressLine1] = useState("");
    const [addressLine1ErrorMessage, setAddressLine1ErrorMessage] = useState("");
    const [addressLine1Valid, setAddressLine1Valid] = useState(false);
    const [addressLine1Error, setAddressLine1Error] = useState(false);

    const [addressLine2, setAddressLine2] = useState("");

    const [problemTypes, setProblemTypes] = useState([]);
    const [problemType, setProblemType] = useState("");
    const [problemTypeErrorMessage, setProblemTypeErrorMessage] = useState("");
    const [problemTypeValid, setProblemTypeValid] = useState(false);
    const [problemTypeError, setProblemTypeError] = useState(false);

    const [problemDesc, setProblemDesc] = useState("");
    const [problemDescErrorMessage, setProblemDescErrorMessage] = useState("");
    const [problemDescValid, setProblemDescValid] = useState(false);
    const [problemDescError, setProblemDescError] = useState(false);

    const [ackNumber, setAckNumber] = useState("");

    const [alignment, setAlignment] = useState('web');

    const handleChange = (event, newAlignment) => {
        setAlignment(newAlignment);
    };

    const [grievanceOfc, setGrievanceOfc] = useState('');
    const [grievanceOfcValid, setGrievanceOfcValid] = useState(false);
    const [grievanceOfcError, setGrievanceOfcError] = useState(false);
    const [grievanceOfcHelperText, setGrievanceOfcHelperText] = useState('');

    const [supportingDoc, setSupportingDoc] = useState(null);
    const [supportingDocValid, setSupportingDocValid] = useState(false);
    const [supportingDocError, setSupportingDocError] = useState(false);
    const [supportingDocErrorMsg, setSupportingDocErrorMsg] = useState("Select not more than 1MB PDF File");

    const [docketList, setDocketList] = useState([]);
    const [isDocketListFetched, setIsDocketListFetched] = useState(false);
    const [isDocketDetailsFetched, setIsDocketDetailsFetched] = useState(false);
    const [isGrievanceDetailsLoading, setIsGrievanceDetailsLoading] = useState(false);
    const [grievanceDetails, setGrievanceDetails] = useState(null);
    const [clickedDocketNo, setClickedDocketNo] = useState(null);

    const [isAckNoFetched, setIsAckNoFetched] = useState(false);
    const [downloadableFileList, setDownloadableFileList] = useState([]);
    const [isFileDownloadLoading, setIsFileDownloadLoading] = useState(false);
    const [clickedFileIndex, setClickedFileIndex] = useState(null);
    const [isDocketFileDownloadLoading, setIsDocketFileDownloadLoading] = useState(false);

    const resetFrom = () => {
        setConsumerId("");
        setConsumerIdErrorMessage("");
        setConsumerIdDisabled(false);
        setConsumerIdValid(false);
        setConsumerIdError(false);

        setCaptchaText("");
        setCaptchaTextErrorMessage("");
        setCaptchaTextValid(false);
        setCaptchaTextError(false);

        setIsMobileFetched(false);
        setIsMobileVerified(false);
        setIsOTPSent(false);
        setIsFinalSubmitDone(false);

        setVerifyLoading(false);
        setSendOtpLoading(false);
        setOtpVerifyLoading(false);
        setFinalSubmitLoading(false);

        setHasMobileNumber(true);
        setHideMobileEdit(true);

        setConsumerName("");
        setConsumerNameErrorMessage("");
        setConsumerNameValid(false);
        setConsumerNameError(false);

        setConsumerOriginalMobile("");
        setConsumerMobile("");
        setConsumerMobileErrorMessage("");
        setConsumerMobileValid(false);
        setConsumerMobileError(false);

        setEncryptedOtp("");
        setOtpGotFromApi("");
        setOtp("");//538240
        setOtpErrorMessage("");
        setOtpValid(false);
        setOtpError(false);

        setSupplyOfc("");

        setConsumerEmail("");
        setConsumerEmailErrorMessage("");
        setConsumerEmailValid(true);
        setConsumerEmailError(false);

        setAddressLine1("");
        setAddressLine1ErrorMessage("");
        setAddressLine1Valid(false);
        setAddressLine1Error(false);

        setAddressLine2("");

        setProblemType("");
        setProblemTypeErrorMessage("");
        setProblemTypeValid(false);
        setProblemTypeError(false);

        setProblemDesc("");
        setProblemDescErrorMessage("");
        setProblemDescValid(false);
        setProblemDescError(false);

        setAckNumber("");

        setGrievanceOfc('');
        setGrievanceOfcValid(false);
        setGrievanceOfcError(false);
        setGrievanceOfcHelperText('');

        setSupportingDoc(null);
        setSupportingDocValid(false);
        setSupportingDocError(false);
        setSupportingDocErrorMsg("Select not more than 1MB PDF File");

        setTimer(0);
        setOpenErrorDialog(false);
        setErrorDialogMsg("");

        gen();
    }

    const handleGrievanceOfcChange = (event) => {
        setGrievanceOfc(event.target.value);
        if (event.target.value == "CGRO") {
            setGrievanceOfcHelperText('All proceedings shall be held at Vidyut Bhaban');
            setGrievanceOfcError(false);
            setGrievanceOfcValid(true);
        } else {
            setGrievanceOfcHelperText('');
            setGrievanceOfcError(false);
            setGrievanceOfcValid(true);
        }

    };

    const handleGrievanceFileChange = (event) => {
        const fileExt = event.target.files[0].name.split('.').pop();
        const fileSize = (event.target.files[0].size) / (1 * 1024 * 1024);
        if (fileExt == "pdf" && fileSize <= 1) {
            setSupportingDoc(event.target.files[0]);
            setSupportingDocErrorMsg('');
            setSupportingDocError(false);
            setSupportingDocValid(true);
        } else {
            setSupportingDoc(null);
            setSupportingDocValid(false);
            setSupportingDocError(true);
            if (fileExt != "pdf") {
                setSupportingDocErrorMsg('Please select pdf file only');
            }
            else if (fileSize > 1) {
                setSupportingDocErrorMsg('Please select pdf file with size not greater than 1 MB');
            }
            else {
                setGrievanceOfcHelperText('Sometthing wrong with the file. try other file');
            }
        }
    };

    useEffect(() => {
        if (props && props.prepopulatedConsumerId && props.prepopulatedConsumerId.match(consumerIdPattern)) {
            console.log("cid valid");
            setConsumerIdErrorMessage("");
            setConsumerIdValid(true);
            setConsumerId(props.prepopulatedConsumerId);
            setConsumerIdDisabled(true);
        }
        else {
            setConsumerIdDisabled(false);
            setConsumerIdErrorMessage("");
            setConsumerIdValid(false);
        }

    }, [props.prepopulatedConsumerId])


    const captchaRef = useRef();
    const userOpt = {
        type: 'mixed', // "mixed"(default) | "numeric" | "alpha" 
        length: 5, // 4 to 8 number. default is 5
        sensitive: false, // Case sensitivity. default is false
        width: 200, // Canvas width. default is 200
        height: 44, // Canvas height. default is 50
        fontColor: '#000',
        background: 'rgba(255, 255, 255, .2)'
    }
    const { gen, validate } = useCaptcha(captchaRef, userOpt);

    useEffect(() => {
        if (gen) gen();
    }, [gen])

    const handleRefresh = () => { gen(); setCaptchaTextValid(false); }

    const handleSubmit = (event) => {
        event.preventDefault();
        // props.handleTableShow();
        console.log(typeOfQueryValid, consumerIdValid);
        if (typeOfQueryValid && consumerIdValid) {
            setVerifyLoading(true);
            const data = new FormData(event.currentTarget);
            const payload = {
                refType: typeOfQuery.toLowerCase() == "acknowledgement number" ? "ACKNO" : typeOfQuery.toLowerCase() == "consumer id" ? "CONID" : typeOfQuery.toLowerCase() == "application no" ? "APPL" : "DOCKETNO",
                refNum: consumerId,
                // fromDate: dayjs(data.get('fromDate'), "DD/MM/YYYY").format("YYYYMMDD"),
                // toDate: dayjs(data.get('toDate'), "DD/MM/YYYY").format("YYYYMMDD")
            };
            console.log({
                consumerId: consumerId,
                captcha: data.get('captcha'),
                // fromDate: dayjs(data.get('fromDate'), "DD/MM/YYYY").format("YYYYMMDD"),
                // toDate: dayjs(data.get('toDate'), "DD/MM/YYYY").format("YYYYMMDD")
            });
            if (typeOfQuery.toLowerCase() == "docket number") {
                fetchDocketDetails({ docketNo: consumerId });
                setClickedDocketNo(consumerId);
            } else {
                fetchConsumerDocketList(payload);
            }
        }
        else {
            // props.onVerifySubmit();
            if (!consumerIdValid && !typeOfQueryValid) {
                setConsumerIdError(true);
                setTypeOfQueryError(true);
                setConsumerIdErrorMessage(
                    t("Please enter Reference No")
                );
                setTypeOfQueryErrorMessage(
                    t("Please enter type")
                );
            }
            else if (!typeOfQueryValid) {
                setTypeOfQueryError(true);
                setTypeOfQueryErrorMessage(
                    t("Please enter type")
                );
            }
            else if (!consumerIdValid) {
                setConsumerIdError(true);
                setConsumerIdErrorMessage(
                    t("Please enter Reference No")
                );
            }
            else {
                setConsumerIdError(true);
                setTypeOfQueryError(true);
                setConsumerIdErrorMessage(
                    t("Please enter Reference No")
                );
                setTypeOfQueryErrorMessage(
                    t("Please enter type")
                );
            }
        }
    };

    const fetchConsumerDocketList = (inputData) => {
        const message = inputData.refNum + dayjs().format("YYYYMMDD");
        console.log(message);
        const secret = process.env.REACT_APP_ENC_SECRET_KEY;
        const cipherText = CryptoJS.HmacSHA256(message, secret);
        const encData = cipherText.toString(CryptoJS.enc.Base64);
        console.log(encData, "encData");

        axios.post(`${process.env.REACT_APP_API_URL}GrievanceRedressal/FetchGrievanceListByConsumer`, {
            ...inputData,
            checkSum: encData
        }, {
            headers: {
                "Authorization": "Basic " + btoa(`${process.env.REACT_APP_BASIC_AUTH_USERNAME}:${process.env.REACT_APP_BASIC_AUTH_PASSWORD}`)
            }
        }).then((res) => {
            console.log(res.data, "Data");
            setVerifyLoading(false);
            if (typeof res.data == "string") {
                // setErrorMsg(t("Something went wrong. Please try again later"));
                // handleErrorBar();
                // setLoading(false);
            }
            else if (res.data?.EXCEPTION) {
                // setErrorMsg(res.data?.EXCEPTION);
                // handleErrorBar();
                // setLoading(false);
            }
            else {
                let data = res.data;
                if (data?.response?.data?.length > 0) {


                    if (data?.response?.data && inputData.refType == 'ACKNO') {
                        if (data?.response?.data && data?.response?.data[0]?.mobileNumber) {
                            setHideMobileEdit(true);
                            setConsumerMobileValid(true);
                            let maskedMobile = data?.response?.data[0]?.mobileNumber.substring(0, 2) + "XXXXXX" + data?.response?.data[0]?.mobileNumber.substring(data?.response?.data[0]?.mobileNumber.length - 2, data?.response?.data[0]?.mobileNumber.length);
                            setConsumerOriginalMobile(data?.response?.data[0]?.mobileNumber);
                            setConsumerMobile(maskedMobile);
                            setOpenOtpVerifyDialog(true);
                        }



                        setGrievanceDetails(data?.response?.data[0]);
                        // setIsAckNoFetched(true);

                        setIsDocketListFetched(false);
                        setIsDocketDetailsFetched(false);
                    }
                    else {
                        setDocketList(data?.response?.data);
                        setIsAckNoFetched(false);

                        setIsDocketListFetched(true);
                        setIsDocketDetailsFetched(false);
                    }
                }
                else {
                    setDocketList([]);
                    setIsDocketListFetched(false);
                    handleClickOpenErrorDialog("No Results Found");
                }

                // setTimeout(() => {
                //   executeScroll(ref1);
                // }, 100);
                // executeScroll(ref1);
            }
        })
            .catch((err) => {
                // setErrorMsg(t("Something went wrong. Please try again later"));
                // handleErrorBar();
                console.log(err, "Error");
                let data = {
                    "response": {
                        "errorDescription": null,
                        "data": [
                            "3233",
                            "3231",
                            "3226",
                            "3224",
                            "3223",
                            "3225",
                            "3222",
                            "3221",
                            "3220",
                            "3214"
                        ],
                        "message": null,
                        "status": true,
                        "statusCode": 0
                    }
                }
                // let data = {
                //     "response": {
                //         "errorDescription": null,
                //         "data": {
                //             "msg": "Success",
                //             "address2": "DIST-24PGS (S)",
                //             "address1": "VILL-LANGALBARIA",
                //             "mobileNumber": "9090909090",
                //             "supplyOfc": "MAHINAGAR CCC-3113500",
                //             "name": "DIP DDG",
                //             "email": null,
                //             "status": "Y"
                //         },
                //         "message": null,
                //         "status": true,
                //         "statusCode": 0
                //     }
                // }

                if (data?.response?.data?.length > 0) {


                    // if (data?.response?.data && inputData.refType == 'APPLNO') {
                    //     let d = {
                    //         summary: data?.response?.data[0]
                    //     }
                    //     setGrievanceDetails(d);
                    //     setIsAckNoFetched(true);

                    //     setIsDocketListFetched(false);
                    //     setIsDocketDetailsFetched(false);
                    // }
                    // else {
                    //     setDocketList(data?.response?.data);
                    //     setIsAckNoFetched(false);

                    //     setIsDocketListFetched(true);
                    //     setIsDocketDetailsFetched(false);
                    // }
                }
                else {
                    setDocketList([]);
                    setIsDocketListFetched(false);
                    handleClickOpenErrorDialog("No Results Found");
                }



                // handleClickOpenErrorDialog("Something went wrong");
                setVerifyLoading(false);
            })
    }

    const fetchOrderFilesList = (inputData) => {
        return new Promise((resolve, reject) => {
            const message = inputData.refNum + dayjs().format("YYYYMMDD");
            console.log(message);
            const secret = process.env.REACT_APP_ENC_SECRET_KEY;
            const cipherText = CryptoJS.HmacSHA256(message, secret);
            const encData = cipherText.toString(CryptoJS.enc.Base64);
            console.log(encData, "encData");

            axios.post(`${process.env.REACT_APP_API_URL}GrievanceRedressal/FetchOrderFiles`, {
                ...inputData,
                checkSum: encData
            }, {
                headers: {
                    "Authorization": "Basic " + btoa(`${process.env.REACT_APP_BASIC_AUTH_USERNAME}:${process.env.REACT_APP_BASIC_AUTH_PASSWORD}`)
                }
            }).then((res) => {
                console.log(res.data, "Data");
                setVerifyLoading(false);
                if (typeof res.data == "string") {
                    // setErrorMsg(t("Something went wrong. Please try again later"));
                    // handleErrorBar();
                    // setLoading(false);
                }
                else if (res.data?.EXCEPTION) {
                    // setErrorMsg(res.data?.EXCEPTION);
                    // handleErrorBar();
                    // setLoading(false);
                }
                else {
                    let data = res.data;
                    if (data?.response?.data?.length > 0) {
                        setDownloadableFileList(data?.response?.data);
                    }
                    else {
                        setDownloadableFileList([]);
                    }
                }
                resolve();
            })
                .catch((err) => {
                    // setErrorMsg(t("Something went wrong. Please try again later"));
                    // handleErrorBar();
                    console.log(err, "Error");
                    let data = {
                        "response": {
                            "errorDescription": null,
                            "data": [
                                "3233",
                                "3231",
                                "3226",
                                "3224",
                                "3223",
                                "3225",
                                "3222",
                                "3221",
                                "3220",
                                "3214"
                            ],
                            "message": null,
                            "status": true,
                            "statusCode": 0
                        }
                    }
                    // let data = {
                    //     "response": {
                    //         "errorDescription": null,
                    //         "data": {
                    //             "msg": "Success",
                    //             "address2": "DIST-24PGS (S)",
                    //             "address1": "VILL-LANGALBARIA",
                    //             "mobileNumber": "9090909090",
                    //             "supplyOfc": "MAHINAGAR CCC-3113500",
                    //             "name": "DIP DDG",
                    //             "email": null,
                    //             "status": "Y"
                    //         },
                    //         "message": null,
                    //         "status": true,
                    //         "statusCode": 0
                    //     }
                    // }

                    // if (data?.response?.data?.length > 0) {
                    //     setDownloadableFileList(data?.response?.data);
                    // }
                    // else {
                    //     setDownloadableFileList([]);
                    //     // setIsDocketListFetched(false);
                    //     handleClickOpenErrorDialog("No Results Found");
                    // }



                    handleClickOpenErrorDialog("Something went wrong");
                    setVerifyLoading(false);
                    reject();
                })
        })
    }

    const downloadFileFromServer = (inputData, index) => {
        setClickedFileIndex(index)
        const message = inputData.refNum + dayjs().format("YYYYMMDD");
        console.log(message);
        const secret = process.env.REACT_APP_ENC_SECRET_KEY;
        const cipherText = CryptoJS.HmacSHA256(message, secret);
        const encData = cipherText.toString(CryptoJS.enc.Base64);
        console.log(encData, "encData");
        setIsFileDownloadLoading(true);
        // let inputData = {
        //     "fileName": "DS_3225_1718793318366.pdf",
        //     "filePath": "/Documents/RAPDRP/RGRO_SCAN",
        //     "fileType": "application/pdf"
        // };

        axios.post(`${process.env.REACT_APP_API_URL}GrievanceRedressal/DownloadOrderCopies`, {
            ...inputData,
            checkSum: encData
        }, {
            headers: {
                "Authorization": "Basic " + btoa(`${process.env.REACT_APP_BASIC_AUTH_USERNAME}:${process.env.REACT_APP_BASIC_AUTH_PASSWORD}`)
            },
            responseType: "blob"
        }).then((res) => {
            console.log(res.data, "Data");
            setIsFileDownloadLoading(false);
            if (typeof res.data == "string") {
                // setErrorMsg(t("Something went wrong. Please try again later"));
                // handleErrorBar();
                // setLoading(false);
            }
            else if (res.data?.EXCEPTION) {
                // setErrorMsg(res.data?.EXCEPTION);
                // handleErrorBar();
                // setLoading(false);
            }
            else {
                let data = res.data;
                window.open(URL.createObjectURL(data));
            }
        })
            .catch((err) => {
                // setErrorMsg(t("Something went wrong. Please try again later"));
                // handleErrorBar();
                console.log(err, "Error");
                let data = {
                    "response": {
                        "errorDescription": null,
                        "data": [
                            {
                                "reasonedOrderDate": null,
                                "address": "VILL-LANGALBARIA",
                                "mobileNumber": "9679389767",
                                "hearingDate": "2024-11-23 11:00:00",
                                "updatedHearingDate": null,
                                "problemSummary": "hello",
                                "createdOn": null,
                                "docketNo": "3268",
                                "hearingReason": null,
                                "hearingLoc": "ADMINISTRATIVE BLDGPADMAPUKUR,24 PGS(S)",
                                "updatedFinalHearingDate": null,
                                "rgroOfc": "24_PARGANAS(S) RGRO OFFICE-3110000",
                                "refId": "113000079",
                                "finalHearingDate": null,
                                "problemType": "Delay in Restoration of Service",
                                "email": "null",
                                "consumerName": "DIPAK DDG",
                                "status": "OPEN"
                            },
                            {
                                "reasonedOrderDate": null,
                                "address": "Test aDDRESS",
                                "mobileNumber": "9679389767",
                                "hearingDate": "2024-12-23 15:00:00",
                                "updatedHearingDate": null,
                                "problemSummary": "beuj dwjefd i3r",
                                "createdOn": "2024-12-09 16:16:49",
                                "docketNo": "3276",
                                "hearingReason": null,
                                "hearingLoc": "ADMINISTRATIVE BLDGPADMAPUKUR,24 PGS(S)",
                                "updatedFinalHearingDate": null,
                                "rgroOfc": "24_PARGANAS(S) RGRO OFFICE-3110000",
                                "refId": "113000079",
                                "finalHearingDate": null,
                                "problemType": "Billing related problem",
                                "email": "test@yopmail.com",
                                "consumerName": "Test Name",
                                "status": "OPEN"
                            },
                            {
                                "reasonedOrderDate": null,
                                "address": "Test aDDRESS",
                                "mobileNumber": "9679389767",
                                "hearingDate": "2024-12-23 15:00:00",
                                "updatedHearingDate": null,
                                "problemSummary": "beuj dwjefd i3r",
                                "createdOn": "2024-12-09 16:16:34",
                                "docketNo": "3275",
                                "hearingReason": null,
                                "hearingLoc": "ADMINISTRATIVE BLDGPADMAPUKUR,24 PGS(S)",
                                "updatedFinalHearingDate": null,
                                "rgroOfc": "24_PARGANAS(S) RGRO OFFICE-3110000",
                                "refId": "113000079",
                                "finalHearingDate": null,
                                "problemType": "Billing related problem",
                                "email": "test@yopmail.com",
                                "consumerName": "Test Name",
                                "status": "OPEN"
                            },
                            {
                                "reasonedOrderDate": null,
                                "address": "Test aDDRESS",
                                "mobileNumber": "9679389767",
                                "hearingDate": "2024-12-18 12:00:00",
                                "updatedHearingDate": null,
                                "problemSummary": "beuj dwjefd i3r",
                                "createdOn": "2024-12-09 16:13:54",
                                "docketNo": "3274",
                                "hearingReason": null,
                                "hearingLoc": "ADMINISTRATIVE BLDGPADMAPUKUR,24 PGS(S)",
                                "updatedFinalHearingDate": null,
                                "rgroOfc": "24_PARGANAS(S) RGRO OFFICE-3110000",
                                "refId": "113000079",
                                "finalHearingDate": null,
                                "problemType": "Billing related problem",
                                "email": "test@yopmail.com",
                                "consumerName": "Test Name",
                                "status": "OPEN"
                            },
                            {
                                "reasonedOrderDate": null,
                                "address": "Test aDDRESS",
                                "mobileNumber": "9679389767",
                                "hearingDate": "2024-12-18 12:00:00",
                                "updatedHearingDate": null,
                                "problemSummary": "beuj dwjefd i3r",
                                "createdOn": "2024-12-09 16:13:00",
                                "docketNo": "3273",
                                "hearingReason": null,
                                "hearingLoc": "ADMINISTRATIVE BLDGPADMAPUKUR,24 PGS(S)",
                                "updatedFinalHearingDate": null,
                                "rgroOfc": "24_PARGANAS(S) RGRO OFFICE-3110000",
                                "refId": "113000079",
                                "finalHearingDate": null,
                                "problemType": "Billing related problem",
                                "email": "test@yopmail.com",
                                "consumerName": "Test Name",
                                "status": "OPEN"
                            },
                            {
                                "reasonedOrderDate": null,
                                "address": "VILL-LANGALBARIA",
                                "mobileNumber": "9679389767",
                                "hearingDate": "2024-11-23 14:00:00",
                                "updatedHearingDate": null,
                                "problemSummary": "test ubiok",
                                "createdOn": "2024-11-22 00:00:00",
                                "docketNo": "3269",
                                "hearingReason": null,
                                "hearingLoc": "CRM Cell, Vidyut Bhavan, 1st Floor, 'C' Block, Salt Lake, Kolkata - 700091",
                                "updatedFinalHearingDate": null,
                                "rgroOfc": "24_PARGANAS(S) RGRO OFFICE-3110000",
                                "refId": "113000079",
                                "finalHearingDate": null,
                                "problemType": "Material Cost Refund",
                                "email": "debasubhra.mukherjee@tcs.com",
                                "consumerName": "DIPAK DDG",
                                "status": "OPEN"
                            },
                            {
                                "reasonedOrderDate": "2024-09-24 00:00:00",
                                "address": "VILL-LANGALBARIA",
                                "mobileNumber": "9090909090",
                                "hearingDate": "2024-09-24 12:00:00",
                                "updatedHearingDate": "2024-09-25 15:00:00",
                                "problemSummary": "PROBLEM",
                                "createdOn": "2024-09-23 16:54:50",
                                "docketNo": "3233",
                                "hearingReason": "Petitioner's requirement",
                                "hearingLoc": "ADMINISTRATIVE BLDGPADMAPUKUR,24 PGS(S)",
                                "updatedFinalHearingDate": "2024-09-25 14:00:00",
                                "rgroOfc": "24_PARGANAS(S) RGRO OFFICE-3110000",
                                "refId": "113000079",
                                "finalHearingDate": "2024-09-24 12:00:00",
                                "problemType": "Proportionate Cost",
                                "email": "deba@gmail.com",
                                "consumerName": "DIP DDG",
                                "status": "OPEN"
                            },
                            {
                                "reasonedOrderDate": null,
                                "address": "VILL-LANGALBARIA",
                                "mobileNumber": "9748931128",
                                "hearingDate": "2024-07-09 14:00:00",
                                "updatedHearingDate": "2024-07-10 15:00:00",
                                "problemSummary": "ACFG",
                                "createdOn": "2024-07-08 12:14:42",
                                "docketNo": "3231",
                                "hearingReason": "Miscellaneous",
                                "hearingLoc": "ADMINISTRATIVE BLDGPADMAPUKUR,24 PGS(S)",
                                "updatedFinalHearingDate": null,
                                "rgroOfc": "24_PARGANAS(S) RGRO OFFICE-3110000",
                                "refId": "113000079",
                                "finalHearingDate": null,
                                "problemType": "Material Cost Refund",
                                "email": null,
                                "consumerName": "DIP DDG",
                                "status": "OPEN"
                            },
                            {
                                "reasonedOrderDate": null,
                                "address": "SERVICE CONNECTION 1",
                                "mobileNumber": "9090909090",
                                "hearingDate": "2024-06-27 14:00:00",
                                "updatedHearingDate": null,
                                "problemSummary": "PORBLEM",
                                "createdOn": "2024-06-25 17:06:42",
                                "docketNo": "3226",
                                "hearingReason": null,
                                "hearingLoc": "CRM CELL, VIDYUT BHAVAN, 1ST FLOOR, 'C' BLOCK, SALT LAKE, KOLKATA - 700091",
                                "updatedFinalHearingDate": null,
                                "rgroOfc": "CRM_CELL",
                                "refId": "113000079",
                                "finalHearingDate": null,
                                "problemType": "Proportionate Cost",
                                "email": "deba@gmail.com",
                                "consumerName": "DIP DDG",
                                "status": "COMPLETED"
                            },
                            {
                                "reasonedOrderDate": null,
                                "address": "SERVICE CONNECTION 1",
                                "mobileNumber": "8900793546",
                                "hearingDate": "2024-06-20 15:00:00",
                                "updatedHearingDate": null,
                                "problemSummary": "DVDV",
                                "createdOn": "2024-06-19 15:37:01",
                                "docketNo": "3224",
                                "hearingReason": null,
                                "hearingLoc": "ADMINISTRATIVE BLDGPADMAPUKUR,24 PGS(S)",
                                "updatedFinalHearingDate": null,
                                "rgroOfc": "24_PARGANAS(S) RGRO OFFICE-3110000",
                                "refId": "113000079",
                                "finalHearingDate": null,
                                "problemType": "Security Deposit Refund",
                                "email": "sub.saha1971@gmail.com",
                                "consumerName": "DIP DDG",
                                "status": "OPEN"
                            }
                        ],
                        "message": null,
                        "status": true,
                        "statusCode": 0
                    }
                }
                // let data = {
                //     "response": {
                //         "errorDescription": null,
                //         "data": {
                //             "msg": "Success",
                //             "address2": "DIST-24PGS (S)",
                //             "address1": "VILL-LANGALBARIA",
                //             "mobileNumber": "9090909090",
                //             "supplyOfc": "MAHINAGAR CCC-3113500",
                //             "name": "DIP DDG",
                //             "email": null,
                //             "status": "Y"
                //         },
                //         "message": null,
                //         "status": true,
                //         "statusCode": 0
                //     }
                // }

                if (data?.response?.data?.length > 0) {


                    // if (data?.response?.data && inputData.refType == 'APPLNO') {
                    //     let d = {
                    //         summary: data?.response?.data[0]
                    //     }
                    //     setGrievanceDetails(d);
                    //     setIsAckNoFetched(true);

                    //     setIsDocketListFetched(false);
                    //     setIsDocketDetailsFetched(false);
                    // }
                    // else {
                    //     setDocketList(data?.response?.data);
                    //     setIsAckNoFetched(false);

                    //     setIsDocketListFetched(true);
                    //     setIsDocketDetailsFetched(false);
                    // }
                }
                else {
                    setDocketList([]);
                    setIsDocketListFetched(false);
                    handleClickOpenErrorDialog("No Results Found");
                }



                // handleClickOpenErrorDialog("Something went wrong");
                setIsFileDownloadLoading(false);
            })
    }

    const downloadDocketReceipt = (inputData) => {
        const message = inputData.refNum + dayjs().format("YYYYMMDD");
        console.log(message);
        const secret = process.env.REACT_APP_ENC_SECRET_KEY;
        const cipherText = CryptoJS.HmacSHA256(message, secret);
        const encData = cipherText.toString(CryptoJS.enc.Base64);
        console.log(encData, "encData");

        setIsDocketFileDownloadLoading(true);
        // let inputData = {
        //     "fileName": "DS_3225_1718793318366.pdf",
        //     "filePath": "/Documents/RAPDRP/RGRO_SCAN",
        //     "fileType": "application/pdf"
        // };

        axios.post(`${process.env.REACT_APP_API_URL}GrievanceRedressal/DownloadDocketReceipt`, {
            ...inputData,
            checkSum: encData
        }, {
            headers: {
                "Authorization": "Basic " + btoa(`${process.env.REACT_APP_BASIC_AUTH_USERNAME}:${process.env.REACT_APP_BASIC_AUTH_PASSWORD}`)
            },
        }).then((res) => {
            console.log(res.data, "Data");
            setIsDocketFileDownloadLoading(false);
            if (typeof res.data == "string") {
                // setErrorMsg(t("Something went wrong. Please try again later"));
                // handleErrorBar();
                // setLoading(false);
            }
            else if (res.data?.EXCEPTION) {
                // setErrorMsg(res.data?.EXCEPTION);
                // handleErrorBar();
                // setLoading(false);
            }
            else {
                let data = res.data;
                if (data?.response?.data?.length > 0) {
                    const link = document.createElement("a");
                    link.href = data?.response?.data;
                    link.setAttribute(
                        "download",
                        `${inputData.docketNo}.${"pdf"}`
                    );
                    document.body.appendChild(link);
                    link.click();

                    // Clean up and remove the link
                    link.parentNode.removeChild(link);
                }
                else {
                    handleClickOpenErrorDialog("Docket Receipt Not Generated");
                }
            }
        })
            .catch((err) => {
                // setErrorMsg(t("Something went wrong. Please try again later"));
                // handleErrorBar();
                console.log(err, "Error");
                // let data = {
                //     "response": {
                //         "errorDescription": null,
                //         "data": [
                //             "3233",
                //             "3231",
                //             "3226",
                //             "3224",
                //             "3223",
                //             "3225",
                //             "3222",
                //             "3221",
                //             "3220",
                //             "3214"
                //         ],
                //         "message": null,
                //         "status": true,
                //         "statusCode": 0
                //     }
                // }
                // let data = {
                //     "response": {
                //         "errorDescription": null,
                //         "data": {
                //             "msg": "Success",
                //             "address2": "DIST-24PGS (S)",
                //             "address1": "VILL-LANGALBARIA",
                //             "mobileNumber": "9090909090",
                //             "supplyOfc": "MAHINAGAR CCC-3113500",
                //             "name": "DIP DDG",
                //             "email": null,
                //             "status": "Y"
                //         },
                //         "message": null,
                //         "status": true,
                //         "statusCode": 0
                //     }
                // }


                // handleClickOpenErrorDialog("Something went wrong");
                setIsDocketFileDownloadLoading(false);
            })
    }

    const onClickSendOTP = () => {
        console.log(consumerMobileValid);

        if (consumerMobileValid) {
            setSendOtpLoading(true);
            // const data = new FormData(event.currentTarget);
            const payload = {
                mobileNumber: consumerOriginalMobile,
                reSendOtp: "",
                flag: "S"
                // fromDate: dayjs(data.get('fromDate'), "DD/MM/YYYY").format("YYYYMMDD"),
                // toDate: dayjs(data.get('toDate'), "DD/MM/YYYY").format("YYYYMMDD")
            };
            console.log({
                mobileNumber: consumerOriginalMobile,
                // fromDate: dayjs(data.get('fromDate'), "DD/MM/YYYY").format("YYYYMMDD"),
                // toDate: dayjs(data.get('toDate'), "DD/MM/YYYY").format("YYYYMMDD")
            });
            sendOTP(payload);
        }
        else {
            if (!consumerMobileValid) {
                setConsumerMobileError(true);
                setConsumerMobileErrorMessage(
                    t("Please enter valid mobile number")
                );
            }
            else {
                setConsumerMobileError(true);
                setConsumerMobileErrorMessage(
                    t("Please enter mobile number")
                );
            }
        }
    }

    const sendOTP = (inputData) => {
        const message = inputData.mobileNumber + dayjs().format("YYYYMMDD");
        console.log(message);
        const secret = process.env.REACT_APP_ENC_SECRET_KEY;
        const cipherText = CryptoJS.HmacSHA256(message, secret);
        const encData = cipherText.toString(CryptoJS.enc.Base64);
        console.log(encData, "encData");

        axios.post(`${process.env.REACT_APP_API_URL}GrievanceRedressal/SendOTP`, {
            ...inputData,
            checkSum: encData
        }, {
            headers: {
                "Authorization": "Basic " + btoa(`${process.env.REACT_APP_BASIC_AUTH_USERNAME}:${process.env.REACT_APP_BASIC_AUTH_PASSWORD}`)
            }
        }).then((res) => {
            console.log(res.data, "Data");
            setSendOtpLoading(false);
            if (typeof res.data == "string") {
                // setErrorMsg(t("Something went wrong. Please try again later"));
                // handleErrorBar();
                // setLoading(false);
            }
            else if (res.data?.EXCEPTION) {
                // setErrorMsg(res.data?.EXCEPTION);
                // handleErrorBar();
                // setLoading(false);
            }
            else {
                let data = res.data;
                if (data?.response?.data?.otpValue) {
                    let otp = decryptOtp(data?.response?.data?.otpValue);
                    setEncryptedOtp(data?.response?.data?.otpValue);
                    setOtpGotFromApi(otp);
                    setOtp("");

                    resetTimer();
                    setIsOTPSent(true);
                    setHideMobileEdit(false);
                    setIsMobileFetched(true);
                }
                else {
                    setEncryptedOtp("");
                    setOtpGotFromApi("");
                    setOtp("");
                    setIsOTPSent(false);
                    setHideMobileEdit(true);
                    setIsMobileFetched(true);
                }
                setSendOtpLoading(false);


                // setTimeout(() => {
                //   executeScroll(ref1);
                // }, 100);
                // executeScroll(ref1);
            }
        })
            .catch((err) => {
                // setErrorMsg(t("Something went wrong. Please try again later"));
                // handleErrorBar();
                console.log(err, "Error");
                let data = {
                    "response": {
                        "errorDescription": null,
                        "data": {
                            "otpValue": "Ytegtd1lIskq60gIA7cqjA=="
                        },
                        "message": null,
                        "status": true,
                        "statusCode": 0
                    }
                }

                // if (data?.response?.data?.otpValue) {
                //     let otp = decryptOtp(data?.response?.data?.otpValue);
                //     setEncryptedOtp(data?.response?.data?.otpValue);
                //     setOtpGotFromApi(otp);
                //     setOtp("");

                //     resetTimer();
                //     setIsOTPSent(true);
                //     setHideMobileEdit(false);
                //     setIsMobileFetched(true);
                // }
                // else {
                //     setEncryptedOtp("");
                //     setOtpGotFromApi("");
                //     setOtp("");
                //     setIsOTPSent(false);
                //     setHideMobileEdit(true);
                //     setIsMobileFetched(true);
                // }

                handleClickOpenErrorDialog("Something went wrong");
                setSendOtpLoading(false);
            })
    }

    useEffect(() => {
        console.log(problemType, "&&&&&&");
    }, [problemType])


    const requestHearingDateChange = (inputData) => {
        setHearingDateChangeLoading(true);
        const message = dayjs().format("YYYYMMDD");
        console.log(message);
        const secret = process.env.REACT_APP_ENC_SECRET_KEY;
        const cipherText = CryptoJS.HmacSHA256(message, secret);
        const encData = cipherText.toString(CryptoJS.enc.Base64);
        console.log(encData, "encData");

        axios.post(`${process.env.REACT_APP_API_URL}GrievanceRedressal/RequestForHearingDateChange`, {
            ...inputData,
            checkSum: encData
        }, {
            headers: {
                "Authorization": "Basic " + btoa(`${process.env.REACT_APP_BASIC_AUTH_USERNAME}:${process.env.REACT_APP_BASIC_AUTH_PASSWORD}`)
            }
        }).then(async (res) => {
            console.log(res.data, "Data");

            setHearingDateChangeLoading(false);
            // setClickedDocketNo(null);
            if (typeof res.data == "string") {
                // setErrorMsg(t("Something went wrong. Please try again later"));
                // handleErrorBar();
                // setLoading(false);
            }
            else if (res.data?.EXCEPTION) {
                // setErrorMsg(res.data?.EXCEPTION);
                // handleErrorBar();
                // setLoading(false);
            }
            else {
                let data = res.data;
                if (data?.response?.status == false) {
                    setHearingDateDialogHeading("Response");
                    setHearingDateDialogMsg(data?.response?.message);
                    setHearingDateChangeError(true);
                    setIsHearingDateChangeRequested(true);
                }
                else {
                    setHearingDateDialogHeading("Response")
                    setHearingDateDialogMsg(data?.response?.message);
                    setHearingDateChangeError(false);
                    setIsHearingDateChangeRequested(true);
                }
            }
        })
            .catch((err) => {
                // setErrorMsg(t("Something went wrong. Please try again later"));
                // handleErrorBar();
                console.log(err, "Error");
                // let data = {
                //     "response": {
                //         "errorDescription": null,
                //         "data": [
                //             "Billing related problem",
                //             "Problem in effecting new connection"
                //         ],
                //         "message": null,
                //         "status": true,
                //         "statusCode": 0
                //     }
                // }

                // if (data?.response?.data?.length > 0) {
                //     setProblemTypes(data?.response?.data);
                // }
                // else {
                //     setProblemTypes([]);
                // }
                let data = {
                    "response": {
                        "errorDescription": null,
                        "data": null,
                        "message": "Hearing request update for docket 3233 already present.",
                        "status": false,
                        "statusCode": 0
                    }
                }

                // if (data?.response?.status == false) {
                //     setHearingDateDialogHeading("Response");
                //     setHearingDateDialogMsg(data?.response?.message);
                //     setHearingDateChangeError(true);
                //     setIsHearingDateChangeRequested(true);
                // }
                // else {
                //     setHearingDateDialogHeading("Response")
                //     setHearingDateDialogMsg(data?.response?.message);
                //     setHearingDateChangeError(false);
                //     setIsHearingDateChangeRequested(true);
                // }

                handleClickOpenErrorDialog("Something went wrong");
                setHearingDateChangeLoading(false);
            })
    }

    const onClickEditMobileButton = () => {
        setConsumerMobile("");
        setHideMobileEdit(false);
        setHasMobileNumber(false);
        setConsumerMobileValid(false);
    }

    const decryptOtp = (encryptedOTP) => {
        let encryptedBase64Key = process.env.REACT_APP_QUERY_STRING_SECRET_KEY;
        let parsedBase64Key = CryptoJS.enc.Base64.parse(encryptedBase64Key);

        let encryptedCipherText = encryptedOTP;

        let decryptedData = CryptoJS.AES.decrypt(encryptedCipherText, parsedBase64Key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });

        let decryptedText = decryptedData.toString(CryptoJS.enc.Utf8);
        console.log("DecryptedText = " + decryptedText);
        return decryptedText;
    }

    const onClickVerifyOTP = async () => {
        let isOtpValid = false;
        if (otp && otp.length < 6) {
            setOtpError(true);
        } else {
            setOtpError(false);
        }

        if (!otp) {
            setOtpErrorMessage(
                t("Please enter otp")
            );
        }
        else if (otp?.trim().length < 6) {
            setOtpErrorMessage(
                t("Please enter valid otp")
            );
        }

        if (otp && otp?.trim().length == 6 && otpErrorMessage) {
            setOtpErrorMessage("");
            setOtpValid(true);
            isOtpValid = true;
        }
        else if (otp && otp?.trim().length == 6 && !otpErrorMessage) {
            setOtpErrorMessage("");
            setOtpValid(true);
            isOtpValid = true;
        }
        else if (!otp && otpErrorMessage) {
            setOtpErrorMessage("");
            setOtpValid(false);
            isOtpValid = false;
        }
        else {
            setOtpValid(false);
            isOtpValid = false;
        }


        if (isOtpValid) {
            setOtpVerifyLoading(true);
            // const data = new FormData(event.currentTarget);
            if (otp == otpGotFromApi) {
                // await fetchProblemTypes({})
                //     .then((prob) => {
                setIsMobileVerified(true);
                setIsMobileFetched(true);
                setHideMobileEdit(false);
                setTimer(0);

                setOtpVerifyLoading(false);

                if (typeOfQuery.toLowerCase() == "acknowledgement number") {
                    setIsAckNoFetched(true);
                }
                else {
                    setIsDocketDetailsFetched(true);
                }

                handleCloseOtpVerifyDialog()
                // })
                // .catch((e) => {
                //     handleClickOpenErrorDialog("Something went wrong");
                //     setOtpVerifyLoading(false);
                // });

            } else {
                setOtpError(true);
                setOtpErrorMessage(
                    t("Please enter valid otp")
                );
                setIsMobileVerified(false);
                setIsMobileFetched(true);
                setHideMobileEdit(false);
                setOtpVerifyLoading(false);
            }
        }
        else {
            setOtpError(true);

            setOtpErrorMessage(
                t("Please enter valid otp")
            );
        }
    }

    const [timer, setTimer] = useState(0);
    const timeOutCallback = useCallback(() => setTimer(currTimer => currTimer - 1), []);

    useEffect(() => {
        timer > 0 && setTimeout(timeOutCallback, 1000);
    }, [timer, timeOutCallback]);

    // console.log(timer);

    const resetTimer = function () {
        if (!timer) {
            setTimer(120);
        }
    };

    const fetchDocketDetails = (inputData) => {
        setClickedDocketNo(inputData?.docketNo);
        setIsGrievanceDetailsLoading(true);
        const message = dayjs().format("YYYYMMDD");
        console.log(message);
        const secret = process.env.REACT_APP_ENC_SECRET_KEY;
        const cipherText = CryptoJS.HmacSHA256(message, secret);
        const encData = cipherText.toString(CryptoJS.enc.Base64);
        console.log(encData, "encData");

        axios.post(`${process.env.REACT_APP_API_URL}GrievanceRedressal/FetchGrievanceDetailsFromDocketNo`, {
            ...inputData,
            checkSum: encData
        }, {
            headers: {
                "Authorization": "Basic " + btoa(`${process.env.REACT_APP_BASIC_AUTH_USERNAME}:${process.env.REACT_APP_BASIC_AUTH_PASSWORD}`)
            }
        }).then(async (res) => {
            console.log(res.data, "Data");
            await fetchOrderFilesList(inputData)
                .then((files) => {

                    setIsGrievanceDetailsLoading(false);
                })
                .catch((ex) => {
                    handleClickOpenErrorDialog("Something went wrong");
                    setIsGrievanceDetailsLoading(false);
                });


            setVerifyLoading(false);
            // setClickedDocketNo(null);
            if (typeof res.data == "string") {
                // setErrorMsg(t("Something went wrong. Please try again later"));
                // handleErrorBar();
                // setLoading(false);
            }
            else if (res.data?.EXCEPTION) {
                // setErrorMsg(res.data?.EXCEPTION);
                // handleErrorBar();
                // setLoading(false);
            }
            else {
                let data = res.data;
                setGrievanceDetails(data?.response?.data);

                if (data?.response?.data?.mobileNumber) {
                    setHideMobileEdit(true);
                    setConsumerMobileValid(true);
                    let maskedMobile = data?.response?.data?.mobileNumber.substring(0, 2) + "XXXXXX" + data?.response?.data?.mobileNumber.substring(data?.response?.data?.mobileNumber.length - 2, data?.response?.data?.mobileNumber.length);
                    setConsumerOriginalMobile(data?.response?.data?.mobileNumber);
                    setConsumerMobile(maskedMobile);
                    setOpenOtpVerifyDialog(true);
                }

                setIsGrievanceDetailsLoading(false);
                setVerifyLoading(false);
            }
        })
            .catch((err) => {
                // setErrorMsg(t("Something went wrong. Please try again later"));
                // handleErrorBar();
                console.log(err, "Error");
                // let data = {
                //     "response": {
                //         "errorDescription": null,
                //         "data": [
                //             "Billing related problem",
                //             "Problem in effecting new connection"
                //         ],
                //         "message": null,
                //         "status": true,
                //         "statusCode": 0
                //     }
                // }

                // if (data?.response?.data?.length > 0) {
                //     setProblemTypes(data?.response?.data);
                // }
                // else {
                //     setProblemTypes([]);
                // }
                let data = {
                    "response": {
                        "errorDescription": null,
                        "data": {
                            "msg": "Data fetched successfully",
                            "summary": "hello",
                            "reasonedOrderDate": null,
                            "flag": "Y",
                            "address": "VILL-LANGALBARIA",
                            "mobileNumber": "9679389767",
                            "hearingDate": "2024-11-23",
                            "updatedHearingDate": null,
                            "creationDate": null,
                            "updatedHearingReason": null,
                            "refNum": "113000079",
                            "hearingLoc": "ADMINISTRATIVE BLDGPADMAPUKUR,24 PGS(S)",
                            "complaintType": "Delay in Restoration of Service",
                            "updatedFinalHearingDate": null,
                            "rgroOfc": "24_PARGANAS(S) RGRO OFFICE-3110000",
                            "finalHearingDate": null,
                            "email": "null",
                            "status": "OPEN",
                            "consumerName": "DIPAK DDG"
                        },
                        "message": null,
                        "status": true,
                        "statusCode": 0
                    }
                }

                // setGrievanceDetails(data?.response?.data);

                // if(data?.response?.data?.mobileNumber) {
                //     setHideMobileEdit(true);
                //     setConsumerMobileValid(true);
                //     setConsumerMobile(data?.response?.data?.mobileNumber);
                //     setOpenOtpVerifyDialog(true);
                // }

                setIsGrievanceDetailsLoading(false);
                setVerifyLoading(false);
            })
    }

    const fetchDocketDetailsFromAckNo = (inputData) => {
        setClickedDocketNo(inputData?.docketNo);
        setIsGrievanceDetailsLoading(true);
        const message = dayjs().format("YYYYMMDD");
        console.log(message);
        const secret = process.env.REACT_APP_ENC_SECRET_KEY;
        const cipherText = CryptoJS.HmacSHA256(message, secret);
        const encData = cipherText.toString(CryptoJS.enc.Base64);
        console.log(encData, "encData");

        axios.post(`${process.env.REACT_APP_API_URL}GrievanceRedressal/FetchGrievanceDetailsFromDocketNo`, {
            ...inputData,
            checkSum: encData
        }, {
            headers: {
                "Authorization": "Basic " + btoa(`${process.env.REACT_APP_BASIC_AUTH_USERNAME}:${process.env.REACT_APP_BASIC_AUTH_PASSWORD}`)
            }
        }).then(async (res) => {
            console.log(res.data, "Data");
            await fetchOrderFilesList(inputData)
                .then((files) => {

                    setIsGrievanceDetailsLoading(false);
                })
                .catch((ex) => {
                    handleClickOpenErrorDialog("Something went wrong");
                    setIsGrievanceDetailsLoading(false);
                });


            setVerifyLoading(false);
            // setClickedDocketNo(null);
            if (typeof res.data == "string") {
                // setErrorMsg(t("Something went wrong. Please try again later"));
                // handleErrorBar();
                // setLoading(false);
            }
            else if (res.data?.EXCEPTION) {
                // setErrorMsg(res.data?.EXCEPTION);
                // handleErrorBar();
                // setLoading(false);
            }
            else {
                let data = res.data;
                setGrievanceDetails(data?.response?.data);
                setIsAckNoFetched(false);
                setIsDocketDetailsFetched(true);
                setIsGrievanceDetailsLoading(false);
                setVerifyLoading(false);
            }
        })
            .catch((err) => {
                // setErrorMsg(t("Something went wrong. Please try again later"));
                // handleErrorBar();
                console.log(err, "Error");
                // let data = {
                //     "response": {
                //         "errorDescription": null,
                //         "data": [
                //             "Billing related problem",
                //             "Problem in effecting new connection"
                //         ],
                //         "message": null,
                //         "status": true,
                //         "statusCode": 0
                //     }
                // }

                // if (data?.response?.data?.length > 0) {
                //     setProblemTypes(data?.response?.data);
                // }
                // else {
                //     setProblemTypes([]);
                // }
                let data = {
                    "response": {
                        "errorDescription": null,
                        "data": {
                            "msg": "Data fetched successfully",
                            "summary": "hello",
                            "reasonedOrderDate": null,
                            "flag": "Y",
                            "address": "VILL-LANGALBARIA",
                            "mobileNumber": "9679389767",
                            "hearingDate": "2024-11-23",
                            "updatedHearingDate": null,
                            "creationDate": null,
                            "updatedHearingReason": null,
                            "refNum": "113000079",
                            "hearingLoc": "ADMINISTRATIVE BLDGPADMAPUKUR,24 PGS(S)",
                            "complaintType": "Delay in Restoration of Service",
                            "updatedFinalHearingDate": null,
                            "rgroOfc": "24_PARGANAS(S) RGRO OFFICE-3110000",
                            "finalHearingDate": null,
                            "email": "null",
                            "status": "OPEN",
                            "consumerName": "DIPAK DDG"
                        },
                        "message": null,
                        "status": true,
                        "statusCode": 0
                    }
                }

                // setGrievanceDetails(data?.response?.data);

                // if(data?.response?.data?.mobileNumber) {
                //     setHideMobileEdit(true);
                //     setConsumerMobileValid(true);
                //     setConsumerMobile(data?.response?.data?.mobileNumber);
                //     setOpenOtpVerifyDialog(true);
                // }

                setIsGrievanceDetailsLoading(false);
                setVerifyLoading(false);
            })
    }


    const changeLang = () => {
        if (i18n.language == "en") {
            i18n.changeLanguage("bn")
        } else {
            i18n.changeLanguage("en")
        }
    }


    const [openErrorDialog, setOpenErrorDialog] = useState(false);
    const [errorDialogMsg, setErrorDialogMsg] = useState("");

    const [openOtpVerifyDialog, setOpenOtpVerifyDialog] = useState(false);

    const [openHearingDateChangeDialog, setOpenHearingDateChangeDialog] = useState(false);
    const [hearingDateDialogMsg, setHearingDateDialogMsg] = useState("You want to request for change the Hearing Date?");
    const [hearingDateDialogHeading, setHearingDateDialogHeading] = useState("Are You Sure?");
    const [hearingDateChangeLoading, setHearingDateChangeLoading] = useState(false);
    const [hearingDateChangeError, setHearingDateChangeError] = useState(false);
    const [isHearingDateChangeRequested, setIsHearingDateChangeRequested] = useState(false);

    const handleClickOpenHearingDateChangeDialog = (e) => {
        e.preventDefault();
        setOpenHearingDateChangeDialog(true);
    };

    const handleCloseHearingDateChangeDialog = () => {
        setOpenHearingDateChangeDialog(false);
        setIsHearingDateChangeRequested(false);
        setHearingDateChangeError(false);
        setHearingDateDialogMsg("You want to request for change the Hearing Date?")
        setHearingDateDialogHeading("Are You Sure?")
    };

    const handleClickOpenOtpVerifyDialog = (msg) => {
        setOpenOtpVerifyDialog(true);
    };

    const handleCloseOtpVerifyDialog = () => {
        setOpenOtpVerifyDialog(false);

        setConsumerOriginalMobile("");
        setConsumerMobile("");
        setConsumerMobileErrorMessage("");
        setConsumerMobileValid(false);
        setConsumerMobileError(false);
    };

    const handleClickOpenErrorDialog = (msg) => {
        setOpenErrorDialog(true);
        setErrorDialogMsg(msg);
    };

    const handleCloseErrorDialog = () => {
        setOpenErrorDialog(false);
        setErrorDialogMsg("");
    };

    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
    });

    function createData(name, calories, fat, carbs, protein) {
        return { name, calories, fat, carbs, protein };
    }

    const rows = [
        createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
        createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
        createData('Eclair', 262, 16.0, 24, 6.0),
        createData('Cupcake', 305, 3.7, 67, 4.3),
        createData('Gingerbread', 356, 16.0, 49, 3.9),
    ];

    return (
        <ThemeProvider theme={defaultTheme}>
            <Container component="main" maxWidth="lg">
                <CssBaseline />
                <Dialog
                    open={openErrorDialog}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={handleCloseErrorDialog}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>{"Error"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            {errorDialogMsg}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseErrorDialog}>OK</Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={openOtpVerifyDialog}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={handleCloseOtpVerifyDialog}
                    aria-describedby="alert-dialog-slide-description"
                    fullWidth={true}
                    maxWidth={'sm'}
                >
                    <DialogTitle>{"Verify Mobile Number"}</DialogTitle>
                    <DialogContent>
                        {true && <>

                            <Grid size={12}>
                                <Stack direction="row" spacing={2} style={{ width: '100%', position: 'relative', marginTop: 10 }}>
                                    <TextField
                                        required
                                        fullWidth
                                        name="mobile"
                                        label={t("Mobile Number")}
                                        type="text"
                                        id="mobile"
                                        autoComplete="false"
                                        disabled={isOTPSent || isMobileVerified || hasMobileNumber}
                                        // inputProps={{ maxLength: 5 }}
                                        helperText={consumerMobileErrorMessage}
                                        value={consumerMobile}
                                        onInput={(e) => {
                                            console.log("cid fired");
                                            setConsumerMobile(e.target.value);
                                            if ((e.target.value && e.target.value.match(mobileNumberPattern))) {
                                                setConsumerMobileError(false);
                                            } else {
                                                setConsumerMobileError(true);
                                            }

                                            if (!e.target.value) {
                                                setConsumerMobileErrorMessage(
                                                    t("Please enter mobile number")
                                                );
                                            }
                                            else if (!e.target.value.match(mobileNumberPattern)) {
                                                setConsumerMobileErrorMessage(
                                                    t("Please enter valid mobile number")
                                                );
                                            }
                                            console.log(consumerMobileErrorMessage);
                                            if (e.target.value.match(mobileNumberPattern) && consumerMobileErrorMessage) {
                                                console.log("cid valid");
                                                setConsumerMobileErrorMessage("");
                                                setConsumerMobileValid(true);
                                            }
                                            else if (e.target.value.match(mobileNumberPattern) && !consumerMobileErrorMessage) {
                                                console.log("cid valid");
                                                setConsumerMobileErrorMessage("");
                                                setConsumerMobileValid(true);
                                            }
                                            else if (e.target.value.length == 0 && consumerMobileErrorMessage) {
                                                setConsumerMobileErrorMessage("");
                                                setConsumerMobileValid(false);
                                            }
                                            else {
                                                setConsumerMobileValid(false);
                                            }

                                        }}
                                        error={consumerMobileError}
                                    />
                                </Stack>
                            </Grid>
                            {isOTPSent && !isMobileVerified &&
                                <Grid size={12} sx={{ mt: 2 }}>
                                    <TextField
                                        required
                                        fullWidth
                                        name="otpVerify"
                                        label={t("OTP")}
                                        type="text"
                                        id="otpVerify"
                                        autoComplete="false"
                                        // inputProps={{ maxLength: 5 }}
                                        helperText={otpErrorMessage}
                                        value={otp}
                                        onInput={(e) => {
                                            setOtp(e.target.value);
                                        }}
                                        error={otpError}
                                    />
                                </Grid>
                            }
                        </>
                        }
                    </DialogContent>
                    <DialogActions>

                        {!isMobileVerified &&
                            <>
                                {isOTPSent ?
                                    <>
                                        {otpVerifyLoading ?
                                            <LoadingButton
                                                size="large"
                                                onClick={() => setOtpVerifyLoading(true)}
                                                loading={otpVerifyLoading}
                                                loadingPosition="start"
                                                startIcon={<SendIcon />}
                                            >
                                                <span>{t("Verifing OTP")}...</span>
                                            </LoadingButton>
                                            :
                                            <Button
                                                onClick={onClickVerifyOTP}
                                            >
                                                {t("Verify OTP")}
                                            </Button>
                                        }
                                    </>
                                    :
                                    <>
                                        {sendOtpLoading ?
                                            <LoadingButton
                                                size="large"
                                                onClick={() => setSendOtpLoading(true)}
                                                loading={sendOtpLoading}
                                                loadingPosition="start"
                                                startIcon={<SendIcon />}
                                            >
                                                <span>{t("Sending OTP")}...</span>
                                            </LoadingButton>
                                            :
                                            <Button
                                                onClick={onClickSendOTP}
                                            >
                                                {t("Send OTP")}
                                            </Button>
                                        }
                                    </>
                                }
                                <>
                                    {
                                        isOTPSent ?
                                            timer == 0 ?
                                                sendOtpLoading ?
                                                    <LoadingButton
                                                        onClick={() => setSendOtpLoading(true)}
                                                        loading={sendOtpLoading}
                                                        loadingPosition="start"
                                                        startIcon={<SendIcon />}
                                                    >
                                                        <span>{t("Sending OTP")}...</span>
                                                    </LoadingButton>
                                                    :
                                                    <Button
                                                        color='error'
                                                        onClick={onClickSendOTP}
                                                    >
                                                        {t("Resend OTP")}
                                                    </Button>
                                                :
                                                <Button
                                                    disabled
                                                    color='error'
                                                >
                                                    {t("Resend OTP in " + timer + " seconds")}
                                                </Button>
                                            :
                                            <Button
                                                color='error'
                                                onClick={handleCloseOtpVerifyDialog}
                                            >
                                                {t("Cancel")}
                                            </Button>
                                    }
                                </>
                            </>
                        }
                        {/* <Button onClick={handleCloseOtpVerifyDialog}>Send OTP</Button> */}
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={openHearingDateChangeDialog}
                    onClose={handleCloseHearingDateChangeDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {hearingDateDialogHeading}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description" sx={{ color: hearingDateChangeError ? colors.red : "#000" }}>
                            {hearingDateDialogMsg}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        {
                            isHearingDateChangeRequested ?
                                <Button onClick={handleCloseHearingDateChangeDialog}>OK</Button>
                                :
                                hearingDateChangeLoading ?
                                    <LoadingButton
                                        onClick={null}
                                        disabled
                                        loading={hearingDateChangeLoading}
                                        loadingPosition="start"
                                        startIcon={<SendIcon />}
                                    >
                                        <span>{t("Requesting")}...</span>
                                    </LoadingButton>
                                    :
                                    <>
                                        <Button color='error' onClick={handleCloseHearingDateChangeDialog}>Cancel</Button>
                                        <Button onClick={() => requestHearingDateChange({ docketNo: clickedDocketNo })} autoFocus>
                                            Proceed
                                        </Button>
                                    </>
                        }
                    </DialogActions>
                </Dialog>

                {/* <Fab onClick={changeLang} color="primary" aria-label="add" variant="extended" sx={{
                    position: "absolute",
                    top: matches ? 120 : 160,
                    right: 6,
                    display: { xs: 'block', sm: "none", md: 'none', lg: 'none', xl: "none" }
                }}>
                    {t("English")}
                </Fab>
                <Fab onClick={changeLang} color="primary" aria-label="add" variant="extended" sx={{
                    position: "absolute",
                    top: 120,
                    right: 6,
                    display: { xs: 'none', sm: "block", md: 'none', lg: 'none', xl: "none" }
                }}>
                    {t("English")}
                </Fab>
                <Fab onClick={changeLang} color="primary" aria-label="add" variant="extended" sx={{
                    position: "absolute",
                    top: 112,
                    right: 6,
                    display: { xs: 'none', sm: "none", md: 'block', lg: 'none', xl: "none" }
                }}>
                    {t("English")}
                </Fab>
                <Fab onClick={changeLang} color="primary" aria-label="add" variant="extended" sx={{
                    position: "absolute",
                    top: 120,
                    right: 6,
                    display: { xs: 'none', sm: "none", md: 'none', lg: 'block', xl: "none" }
                }}>
                    {t("English")}
                </Fab>
                <Fab onClick={changeLang} color="primary" aria-label="add" variant="extended" sx={{
                    position: "absolute",
                    top: 125,
                    right: 6,
                    display: { xs: 'none', sm: "none", md: 'none', lg: 'none', xl: "block" }
                }}>
                    {t("English")}
                </Fab> */}
                <Box
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <img src="images/logo.png" className="img-fluid" alt="WBSEDCL" />
                    {/* <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                        <img src="images/logo.png" height={24} width={24} className="img-fluid" alt="WBSEDCL" />
                    </Avatar> */}
                    <Typography component="h1" variant="h5" textAlign={"center"} sx={{ mt: 2 }}>
                        {t("Know Status of Your Grievance (CGRO/RGRO)")}
                    </Typography>
                    {
                        isFinalSubmitDone &&
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                // minHeight: '100vh'
                                mt: 5
                            }}
                        >
                            <Container>
                                <Grid container spacing={2}>
                                    <Grid size={{ xs: 12 }}>
                                        <Paper elevation={3} className="boxPaper" sx={{
                                            transition: 'linear 0.6s',
                                            color: 'primary.main',
                                            '&:hover': {
                                                backgroundColor: 'primary.main',
                                                color: '#fff',
                                                // boxShadow: '0px 0px 8px 3px rgba(0,0,0,0.5)',
                                            },
                                            padding: 10,
                                            textAlign: "center",
                                            alignItems: 'center',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            fontWeight: 600,
                                            textTransform: 'uppercase',
                                            color: '#005696',
                                            letterSpacing: 1,
                                            cursor: 'pointer',
                                        }}>
                                            {t("Your Grievance is successfully submitted")}<br />
                                            {t("Your Acknowledgement Number for future reference is")}<br />
                                            {ackNumber}
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </Container>
                        </Box>
                    }
                    {!isFinalSubmitDone &&
                        <div style={{ width: isBiggerScreen ? "67%" : "100%" }}>
                            <Box component="form" maxWidth="lg" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>

                                {!(isAckNoFetched || isDocketDetailsFetched || isDocketListFetched) &&
                                    <Grid container spacing={2}>
                                        <Grid size={12}>
                                            <TextField
                                                select
                                                required
                                                fullWidth
                                                name="typeOfQuery"
                                                label={t("Please Select")}
                                                type="text"
                                                id="typeOfQuery"
                                                autoComplete="false"
                                                // inputProps={{ maxLength: 5 }}
                                                helperText={typeOfQueryErrorMessage}
                                                value={typeOfQuery}
                                                onChange={(e) => {
                                                    setTypeOfQuery(e.target.value);
                                                    if (e.target.value && e.target.value.length >= 3) {
                                                        setTypeOfQueryError(false);
                                                    } else {
                                                        setTypeOfQueryError(true);
                                                    }

                                                    if (!e.target.value) {
                                                        setTypeOfQueryErrorMessage(
                                                            t("Please select type")
                                                        );
                                                    }
                                                    else if (e.target.value?.trim().length < 3) {
                                                        setTypeOfQueryErrorMessage(
                                                            t("Please select type")
                                                        );
                                                    }

                                                    if (e.target.value && e.target.value?.trim().length >= 3 && typeOfQueryErrorMessage) {
                                                        setTypeOfQueryErrorMessage("");
                                                        setTypeOfQueryValid(true);
                                                    }
                                                    else if (e.target.value && e.target.value?.trim().length >= 3 && !typeOfQueryErrorMessage) {
                                                        setProblemTypeErrorMessage("");
                                                        setTypeOfQueryValid(true);
                                                    }
                                                    else if (!e.target.value && typeOfQueryErrorMessage) {
                                                        setTypeOfQueryErrorMessage("");
                                                        setTypeOfQueryValid(false);
                                                    }
                                                    else {
                                                        setTypeOfQueryValid(false);
                                                    }
                                                }}
                                                error={typeOfQueryError}
                                            >
                                                {typeOfQueries.map((option, index) => (
                                                    <MenuItem key={index.toString()} value={option}>
                                                        {option}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </Grid>

                                        {typeOfQuery && <Grid size={12}>
                                            <TextField
                                                required
                                                fullWidth
                                                disabled={consumerIdDisabled}
                                                id="consumerId"
                                                label={t(`${typeOfQuery}`)}
                                                name="consumerId"
                                                autoComplete="consumerId"
                                                helperText={consumerIdErrorMessage}
                                                value={consumerId}
                                                slotProps={{
                                                    input: {
                                                        readOnly: isMobileFetched,
                                                    },
                                                }}
                                                // onInput={(e)=>{console.log(e);}}
                                                onInput={(e) => {
                                                    console.log("cid fired");
                                                    setConsumerId(e.target.value);
                                                    if ((e.target.value && e.target.value.match(consumerIdPattern))) {
                                                        setConsumerIdError(false);
                                                    } else {
                                                        setConsumerIdError(true);
                                                    }

                                                    if (!e.target.value) {
                                                        setConsumerIdErrorMessage(
                                                            t("Please enter Consumer Id")
                                                        );
                                                    }
                                                    else if (!e.target.value.match(consumerIdPattern)) {
                                                        setConsumerIdErrorMessage(
                                                            t("Please enter valid Consumer Id")
                                                        );
                                                    }
                                                    console.log(consumerIdErrorMessage);
                                                    if (e.target.value.match(consumerIdPattern) && consumerIdErrorMessage) {
                                                        console.log("cid valid");
                                                        setConsumerIdErrorMessage("");
                                                        setConsumerIdValid(true);
                                                    }
                                                    else if (e.target.value.match(consumerIdPattern) && !consumerIdErrorMessage) {
                                                        console.log("cid valid");
                                                        setConsumerIdErrorMessage("");
                                                        setConsumerIdValid(true);
                                                    }
                                                    else if (e.target.value.length == 0 && consumerIdErrorMessage) {
                                                        setConsumerIdErrorMessage("");
                                                        setConsumerIdValid(false);
                                                    }
                                                    else {
                                                        setConsumerIdValid(false);
                                                    }

                                                }}
                                                error={consumerIdError}
                                            />
                                        </Grid>
                                        }
                                    </Grid>
                                }
                                {!(isAckNoFetched || isDocketDetailsFetched || isDocketListFetched) &&
                                    <>
                                        {verifyLoading ?
                                            <LoadingButton
                                                fullWidth
                                                type="submit"
                                                size="large"
                                                color="primary"
                                                onClick={() => setVerifyLoading(true)}
                                                loading={verifyLoading}
                                                loadingPosition="start"
                                                startIcon={<SendIcon />}
                                                variant="contained"
                                                sx={{ mt: 3, mb: 2 }}
                                            >
                                                <span>{t("Loading")}...</span>
                                            </LoadingButton>
                                            :
                                            <Button
                                                type="submit"
                                                fullWidth
                                                variant="contained"
                                                sx={{ mt: 3, mb: 2 }}
                                            >
                                                {t("Submit")}
                                            </Button>
                                        }
                                    </>
                                }


                                {/* {isMobileFetched && !isMobileVerified &&
                                    <Grid container spacing={2}>
                                        {isOTPSent ?
                                            <Grid size={6}>
                                                {otpVerifyLoading ?
                                                    <LoadingButton
                                                        fullWidth
                                                        type="submit"
                                                        size="large"
                                                        color="primary"
                                                        onClick={() => setOtpVerifyLoading(true)}
                                                        loading={otpVerifyLoading}
                                                        loadingPosition="start"
                                                        startIcon={<SendIcon />}
                                                        variant="contained"
                                                        sx={{ mt: 3, mb: 2 }}
                                                    >
                                                        <span>{t("Verifing OTP")}...</span>
                                                    </LoadingButton>
                                                    :
                                                    <Button
                                                        type="button"
                                                        fullWidth
                                                        variant="contained"
                                                        sx={{ mt: 3, mb: 2 }}
                                                        onClick={onClickVerifyOTP}
                                                    >
                                                        {t("Verify OTP")}
                                                    </Button>
                                                }
                                            </Grid>
                                            :
                                            <Grid size={6}>
                                                {sendOtpLoading ?
                                                    <LoadingButton
                                                        fullWidth
                                                        type="submit"
                                                        size="large"
                                                        color="primary"
                                                        onClick={() => setSendOtpLoading(true)}
                                                        loading={sendOtpLoading}
                                                        loadingPosition="start"
                                                        startIcon={<SendIcon />}
                                                        variant="contained"
                                                        sx={{ mt: 3, mb: 2 }}
                                                    >
                                                        <span>{t("Sending OTP")}...</span>
                                                    </LoadingButton>
                                                    :
                                                    <Button
                                                        type="button"
                                                        fullWidth
                                                        variant="contained"
                                                        sx={{ mt: 3, mb: 2 }}
                                                        onClick={onClickSendOTP}
                                                    >
                                                        {t("Send OTP")}
                                                    </Button>
                                                }
                                            </Grid>
                                        }
                                        <Grid size={6}>
                                            {
                                                isOTPSent ?
                                                    timer == 0 ?
                                                        sendOtpLoading ?
                                                            <LoadingButton
                                                                fullWidth
                                                                type="submit"
                                                                size="large"
                                                                color="primary"
                                                                onClick={() => setSendOtpLoading(true)}
                                                                loading={sendOtpLoading}
                                                                loadingPosition="start"
                                                                startIcon={<SendIcon />}
                                                                variant="contained"
                                                                sx={{ mt: 3, mb: 2 }}
                                                            >
                                                                <span>{t("Sending OTP")}...</span>
                                                            </LoadingButton>
                                                            :
                                                            <Button
                                                                type="reset"
                                                                fullWidth
                                                                variant="contained"
                                                                sx={{ mt: 3, mb: 2 }}
                                                                color='error'
                                                                onClick={onClickSendOTP}
                                                            >
                                                                {t("Resend OTP")}
                                                            </Button>
                                                        :
                                                        <Button
                                                            type="reset"
                                                            fullWidth
                                                            disabled
                                                            variant="contained"
                                                            sx={{ mt: 3, mb: 2 }}
                                                            color='error'
                                                        >
                                                            {t("Resend OTP in " + timer + " seconds")}
                                                        </Button>
                                                    :
                                                    <Button
                                                        type="reset"
                                                        fullWidth
                                                        variant="contained"
                                                        sx={{ mt: 3, mb: 2 }}
                                                        color='error'
                                                        onClick={resetFrom}
                                                    >
                                                        {t("Reset")}
                                                    </Button>
                                            }
                                        </Grid>
                                    </Grid>
                                } */}
                            </Box>
                        </div>
                    }

                    {isDocketListFetched && !isDocketDetailsFetched && !isAckNoFetched &&
                        // <div style={{alignItems:"center", justifyContent: "center"}}>
                        <TableContainer sx={{ maxWidth: 600, mb: 10 }} component={Paper}>
                            <Table sx={{ minWidth: 350 }} size="small" aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Docket Number</TableCell>
                                        <TableCell align="right">View Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {docketList.map((docket) => (
                                        <TableRow
                                            key={docket.docketNo}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                {docket.docketNo}
                                            </TableCell>
                                            <TableCell align="right" onClick={() => fetchDocketDetails({ docketNo: docket.docketNo })}>{(isGrievanceDetailsLoading && clickedDocketNo == docket.docketNo) ? <CircularProgress color="inherit" /> : <RemoveRedEyeTwoToneIcon fontSize="large" />}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        // </div>
                    }

                    {isDocketDetailsFetched &&
                        <TableContainer component={Paper} sx={{ mb: 10 }}>
                            <Table sx={{ minWidth: 350 }} size="small" aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Grievance Status: <span style={{ color: grievanceDetails?.status == "OPEN" ? "#0b661c" : "#f00" ?? "#f00" }}>{grievanceDetails?.status}</span></TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                                <ListItem>
                                                    <ListItemText primary={"Name"} secondary={grievanceDetails?.consumerName} />
                                                </ListItem>
                                            </List>
                                        </TableCell>
                                        <TableCell align="right" onClick={() => { }}><List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                            <ListItem>
                                                <ListItemText primary={"Address"} secondary={grievanceDetails?.address ?? "NA"} />
                                            </ListItem>
                                        </List>
                                        </TableCell>
                                    </TableRow>

                                    <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                                <ListItem>
                                                    <ListItemText primary={"Mobile Number"} secondary={grievanceDetails?.mobileNumber ?? "NA"} />
                                                </ListItem>
                                            </List>
                                        </TableCell>
                                        <TableCell align="right" onClick={() => { }}>
                                            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                                <ListItem>
                                                    <ListItemText primary={"Email"} secondary={grievanceDetails?.email ? grievanceDetails?.email == "null" ? "NA" : grievanceDetails?.email : "NA"} />
                                                </ListItem>
                                            </List>
                                        </TableCell>
                                    </TableRow>

                                    <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                                <ListItem>
                                                    <ListItemText primary={"Grievance Type"} secondary={grievanceDetails?.complaintType} />
                                                </ListItem>
                                            </List>
                                        </TableCell>
                                        <TableCell align="right" onClick={() => { }}>
                                            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                                <ListItem>
                                                    <ListItemText primary={"Grievance Description"} secondary={grievanceDetails?.summary} />
                                                </ListItem>
                                            </List>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                                <ListItem>
                                                    <p></p>
                                                    <ListItemText primary={"Hearing Date & Time"} secondary={grievanceDetails?.hearingDate} />
                                                    {/* <ListItemText primary={"Hearing Date"} secondary={<p>{grievanceDetails?.updatedHearingDate ? grievanceDetails?.updatedHearingDate : grievanceDetails?.hearingDate}  <a href='#' onClick={handleClickOpenHearingDateChangeDialog} style={{ color: "#00f", textDecorationLine: "underline" }}>Request to Change</a></p>} /> */}
                                                </ListItem>
                                            </List>
                                        </TableCell>
                                        <TableCell align="right" onClick={() => { }}>
                                            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                                <ListItem>
                                                    <ListItemText primary={"Hearing Location"} secondary={grievanceDetails?.hearingLoc} />
                                                </ListItem>
                                            </List>
                                        </TableCell>
                                    </TableRow>

                                    <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                                <ListItem>
                                                    <ListItemText primary={"RGRO/CGRO Office"} secondary={grievanceDetails?.rgroOfc ?? "NA"} />
                                                </ListItem>
                                            </List>
                                        </TableCell>
                                        <TableCell align="right" onClick={() => { }}>
                                            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                                <ListItem>
                                                    <ListItemText primary={"Docket Creation Date"} secondary={grievanceDetails?.creationDate ?? "NA"} />
                                                </ListItem>
                                            </List>
                                        </TableCell>
                                    </TableRow>

                                    <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                                <ListItem>
                                                    <ListItemText primary={"Docket Receipt"} secondary={<Button
                                                        type="button"
                                                        startIcon={isDocketFileDownloadLoading ? <CircularProgress color="warning" size={20} /> : <CloudDownloadIcon />}
                                                        variant="contained"
                                                        sx={{ mt: 3, mb: 2 }}
                                                        onClick={() => { downloadDocketReceipt({ ...grievanceDetails, docketNo: clickedDocketNo }) }}
                                                    >
                                                        {t("Download")}
                                                    </Button>} />
                                                </ListItem>
                                            </List>
                                        </TableCell>
                                        <TableCell align="right" onClick={() => { }}>
                                            {downloadableFileList.length > 0 && <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                                <ListItem>
                                                    <ListItemText primary={"Order Files"} secondary={<>
                                                        {downloadableFileList.length > 0 && downloadableFileList.map((file, index) => {
                                                            return (<a href='#' style={{ textAlign: "center", display: "flex", alignItems: "center", justifyContent: "flex-start" }} onClick={(e) => {
                                                                e.preventDefault();
                                                                downloadFileFromServer(file, index);
                                                            }}><span style={{ color: "#00f", textDecorationLine: "underline" }}>{file.fileName}</span>  {(isFileDownloadLoading && clickedFileIndex == index) ? <CircularProgress style={{ marginLeft: 7 }} color="inherit" size={20} /> : <CloudDownloadIcon style={{ marginLeft: 7 }} fontSize="small" />}
                                                            </a>)
                                                        })}
                                                    </>} />
                                                </ListItem>
                                            </List>
                                            }
                                        </TableCell>
                                    </TableRow>

                                    {/* <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                                <ListItem>
                                                    <ListItemText primary={"Upload Supporting Document"} secondary={<Button
                                                        component="label"
                                                        role={undefined}
                                                        variant="contained"
                                                        tabIndex={-1}
                                                        startIcon={<CloudUploadIcon />}
                                                    >
                                                        Upload PDF
                                                        <VisuallyHiddenInput
                                                            type="file"
                                                            onChange={(event) => console.log(event.target.files)}
                                                            multiple
                                                        />
                                                    </Button>} />
                                                </ListItem>
                                            </List>
                                        </TableCell>
                                    </TableRow> */}

                                </TableBody>
                            </Table>
                        </TableContainer>
                    }

                    {isAckNoFetched && typeOfQuery.toLowerCase() == "acknowledgement number" &&
                        <TableContainer component={Paper} sx={{ mb: 10 }}>
                            <Table sx={{ minWidth: 350 }} size="small" aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Acknowledgement Status: <span style={{ color: grievanceDetails?.status == "REJECTED" ? "#f00" : "#0b661c" ?? "#0b661c" }}>{grievanceDetails?.status}</span></TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {grievanceDetails?.status == "REJECTED" ?
                                        <TableRow
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                                    <ListItem>
                                                        <ListItemText primary={"Rejection Reason"} secondary={grievanceDetails?.rejectionReason} />
                                                    </ListItem>
                                                </List>
                                            </TableCell>
                                            <TableCell align="right" onClick={() => { }}>
                                                <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                                    <ListItem>
                                                        <ListItemText primary={"Consumer ID/Application No"} secondary={grievanceDetails?.refId} />
                                                    </ListItem>
                                                </List>
                                            </TableCell>
                                        </TableRow>
                                        :
                                        <TableRow
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                                    <ListItem>
                                                        <ListItemText primary={"Docket No"} secondary={<p>{grievanceDetails?.refDocketNo ?? "NA"}  {grievanceDetails && grievanceDetails.refDocketNo ? isGrievanceDetailsLoading ? <CircularProgress color="inherit" style={{ marginLeft: 7 }} size={20} /> : <a href='#' onClick={(e) => {
                                                            e.preventDefault();
                                                            fetchDocketDetailsFromAckNo({ docketNo: grievanceDetails?.refDocketNo });
                                                        }} style={{ color: "#00f", textDecorationLine: "underline", marginLeft: 7 }}>View Details</a> : null}</p>} />
                                                    </ListItem>
                                                </List>
                                            </TableCell>
                                            <TableCell align="right" onClick={() => { }}>
                                                <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                                    <ListItem>
                                                        <ListItemText primary={"Consumer ID/Application No"} secondary={grievanceDetails?.refId} />
                                                    </ListItem>
                                                </List>
                                            </TableCell>
                                        </TableRow>
                                    }
                                    <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                                <ListItem>
                                                    <ListItemText primary={"Name"} secondary={grievanceDetails?.consumerName} />
                                                </ListItem>
                                            </List>
                                        </TableCell>
                                        <TableCell align="right" onClick={() => { }}><List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                            <ListItem>
                                                <ListItemText primary={"Address"} secondary={grievanceDetails?.address ?? "NA"} />
                                            </ListItem>
                                        </List>
                                        </TableCell>
                                    </TableRow>

                                    <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                                <ListItem>
                                                    <ListItemText primary={"Mobile Number"} secondary={grievanceDetails?.mobileNumber ?? "NA"} />
                                                </ListItem>
                                            </List>
                                        </TableCell>
                                        <TableCell align="right" onClick={() => { }}><List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                            <ListItem>
                                                <ListItemText primary={"Email"} secondary={grievanceDetails?.email ?? "NA"} />
                                            </ListItem>
                                        </List>
                                        </TableCell>
                                    </TableRow>

                                    <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                                <ListItem>
                                                    <ListItemText primary={"Grievance Type"} secondary={grievanceDetails?.problemType} />
                                                </ListItem>
                                            </List>
                                        </TableCell>
                                        <TableCell align="right" onClick={() => { }}><List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                            <ListItem>
                                                <ListItemText primary={"Grievance Description"} secondary={grievanceDetails?.problemSummary} />
                                            </ListItem>
                                        </List>
                                        </TableCell>
                                    </TableRow>
                                    {/* <TableRow
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">
                                        <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                            <ListItem>
                                                <p></p>
                                                <ListItemText primary={"Hearing Date"} secondary={<p>{grievanceDetails?.hearingDate}  <span style={{ color: "#00f", textDecorationLine: "underline" }}>Request to Change</span></p>} />
                                            </ListItem>
                                        </List>
                                    </TableCell>
                                    <TableCell align="right" onClick={() => { }}><List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                        <ListItem>
                                            <ListItemText primary={"Hearing Location"} secondary={grievanceDetails?.hearingLoc} />
                                        </ListItem>
                                    </List>
                                    </TableCell>
                                </TableRow> */}

                                    <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                                <ListItem>
                                                    <ListItemText primary={"RGRO/CGRO Office"} secondary={grievanceDetails?.hearingLoc ?? "NA"} />
                                                </ListItem>
                                            </List>
                                        </TableCell>
                                        <TableCell align="right" onClick={() => { }}><List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                            <ListItem>
                                                <ListItemText primary={"Acknowledgement Creation Date"} secondary={grievanceDetails?.createdOn ?? "NA"} />
                                            </ListItem>
                                        </List>
                                        </TableCell>
                                    </TableRow>



                                </TableBody>
                            </Table>
                        </TableContainer>
                    }
                </Box>
                {/* <Copyright sx={{ mt: 5 }} /> */}
            </Container>
            {
                !isDocketListFetched && !isMobileVerified &&
                <div style={{ height: 200 }}></div>
            }
        </ThemeProvider>
    );
}